export const getDeviceStateHexColor = (color) => {
	switch (color) {
		case "red":
			return "#FF5A5A";
		case "green":
			return "#6BC856";
		case "gray":
			return "#6A6C70";
		case "yellow":
			return "#EEA837";
		default:
			return;
	}
};
